
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        name: 'travelAssistance-tab-three',
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos del Viaje', path: '/asistencia-viajero/datos-viaje' },
                    { text: 'Elegí tu Plan', path: '/asistencia-viajero/plan' },
                ],
                selectedPlanIndex: null as number | null,
                selectedPlanForModal: null as any,
                referente: null,
                // Planes mockeados - TODO: Reemplazar por datos reales del servicio de cotización
                plans: [
                    {
                        id: 1,
                        name: 'Plan Básico',
                        priceFormatted: 'USD 45',
                        priceLabel: 'Por persona / por viaje',
                        recommended: false,
                        covers: [
                            { description: 'Asistencia médica por enfermedad', included: true, capital: 15000, capitalFormatted: 'USD 15.000' },
                            { description: 'Asistencia médica por accidente', included: true, capital: 15000, capitalFormatted: 'USD 15.000' },
                            { description: 'Asistencia odontológica', included: true, capital: 300, capitalFormatted: 'USD 300' },
                            { description: 'Equipaje demorado', included: true, capital: 200, capitalFormatted: 'USD 200' },
                            { description: 'Pérdida de equipaje', included: true, capital: 800, capitalFormatted: 'USD 800' },
                            { description: 'Regreso sanitario', included: true, capital: 15000, capitalFormatted: 'USD 15.000' },
                            { description: 'Cancelación de viaje', included: false, capital: null, capitalFormatted: '' },
                            { description: 'Cobertura por preexistencias', included: false, capital: null, capitalFormatted: '' },
                        ],
                    },
                    {
                        id: 2,
                        name: 'Plan Plus',
                        priceFormatted: 'USD 85',
                        priceLabel: 'Por persona / por viaje',
                        recommended: true,
                        covers: [
                            { description: 'Asistencia médica por enfermedad', included: true, capital: 40000, capitalFormatted: 'USD 40.000' },
                            { description: 'Asistencia médica por accidente', included: true, capital: 40000, capitalFormatted: 'USD 40.000' },
                            { description: 'Asistencia odontológica', included: true, capital: 500, capitalFormatted: 'USD 500' },
                            { description: 'Equipaje demorado', included: true, capital: 400, capitalFormatted: 'USD 400' },
                            { description: 'Pérdida de equipaje', included: true, capital: 1200, capitalFormatted: 'USD 1.200' },
                            { description: 'Regreso sanitario', included: true, capital: 40000, capitalFormatted: 'USD 40.000' },
                            { description: 'Cancelación de viaje', included: true, capital: 1500, capitalFormatted: 'USD 1.500' },
                            { description: 'Cobertura por preexistencias', included: false, capital: null, capitalFormatted: '' },
                        ],
                    },
                    {
                        id: 3,
                        name: 'Plan Premium',
                        priceFormatted: 'USD 150',
                        priceLabel: 'Por persona / por viaje',
                        recommended: false,
                        covers: [
                            { description: 'Asistencia médica por enfermedad', included: true, capital: 100000, capitalFormatted: 'USD 100.000' },
                            { description: 'Asistencia médica por accidente', included: true, capital: 100000, capitalFormatted: 'USD 100.000' },
                            { description: 'Asistencia odontológica', included: true, capital: 1000, capitalFormatted: 'USD 1.000' },
                            { description: 'Equipaje demorado', included: true, capital: 600, capitalFormatted: 'USD 600' },
                            { description: 'Pérdida de equipaje', included: true, capital: 2000, capitalFormatted: 'USD 2.000' },
                            { description: 'Regreso sanitario', included: true, capital: 100000, capitalFormatted: 'USD 100.000' },
                            { description: 'Cancelación de viaje', included: true, capital: 5000, capitalFormatted: 'USD 5.000' },
                            { description: 'Cobertura por preexistencias', included: true, capital: 10000, capitalFormatted: 'USD 10.000' },
                        ],
                    },
                ],
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'quoted';

                const dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const travelData = JSON.parse(sessionStorage.getItem("TravelDetailsData"));

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = dataTabHome ? dataTabHome.lastName : '';
                request.firstName = dataTabHome ? dataTabHome.firstName : '';
                request.phone = dataTabHome ? dataTabHome.areaCode + dataTabHome.telephone : '';
                request.mail = dataTabHome ? dataTabHome.email : '';
                request.quotePlan = this.plans.map(plan => plan.name).join(' - ');
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Destino: " + (travelData && travelData.destination ? travelData.destination.description : '')
                    + " - Tipo de viaje: " + (travelData && travelData.tripType ? travelData.tripType.description : '')
                    + " - Pasajeros: " + (travelData ? travelData.passengersCount : '');

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            selectPlan(plan: any, index: number) {
                NF.UI.Page.block();
                this.selectedPlanIndex = index;

                // Guardar plan seleccionado en sessionStorage
                sessionStorage.setItem("SelectedTravelPlan", JSON.stringify(plan));

                // GTM dataLayer push
                window.globalThis.dataLayer.push({
                    'product': 'asistencia-viajero',
                    'event': 'cotizador-viajero-plan-seleccionado',
                    'plan': plan.name,
                    'referente': this.referente
                });

                // Navegar a la pantalla de datos del contratante
                this.$router.push({ name: 'travelAssistance-policyOwner' });

                NF.UI.Page.unblock();
            },

            openModalCoberturas(plan: any) {
                this.selectedPlanForModal = plan;
                (this.$refs.modalDataCoberturas as any).open();
            },

            closeModalCoberturas() {
                (this.$refs.modalDataCoberturas as any).close();
            },

            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBackFromPlans", "true");
                this.$router.push({
                    name: 'travelAssistance-tab-two',
                });
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                // TODO: Obtener planes reales desde el servicio de cotización
                // Los datos de cotización están en sessionStorage("TravelDetailsData")
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();
                this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
